import { render, staticRenderFns } from "./PropertyEventsSelector.vue?vue&type=template&id=622e8ca4&"
import script from "./PropertyEventsSelector.vue?vue&type=script&lang=js&"
export * from "./PropertyEventsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports